import React, { useEffect, useState } from "react";
import "./MudraApproval.css";
import { useLocation } from "react-router-dom";

export default function MudraApproval() {
    const [userDetail, setUserDetail] = useState({});
const location = useLocation();

const {
  email = "",
  password = "",
} = location.state || {};


useEffect(() => {
  if (!email || !password) return;

  const fetchUser = async () => {
    try {
      const res = await fetch(
        "https://rbhardwaj.com/formapi.php?action=read"
      );
      const data = await res.json();

      const user = data.find(
        (p) => p.email === email && p.password === password
      );

      console.log(user);

      if (user) {
        setUserDetail(user);
      }
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  fetchUser();
}, [email, password]);

  return (
    <div className="letter-wrapper MudraApproval">
      {/* Header */}
      <div className="letter-header">
        <div className="logo left">EMI<br />FINANCE</div>
        <div className="logo center">
          <span>प्रधानमंत्री</span>
          <strong>MUDRA</strong>
          <span>योजना</span>
        </div>
      </div>

     

      {/* Company Info */}
      <div className="company-info">
        <p><strong>AN ISO 9001:2008 CERTIFICATES COMPANY</strong></p>
        <p>
          Incorporated under the National Financial Corporation ACT 1956<br />
          Address : 13rd Floor, Office No.-218,219 & 220, Gokhale Plaza
          Condominium Survey No 186/2/1A, CST 3187, Chinchwad - Akurdi Link Road,
          Near Ramkrishna More, Auditorium, Pune Maharashtra
        </p>
      </div>

      <h2 className="title">APPROVAL LETTER</h2>

      {/* Loan Details */}
      <div className="details">
        <div>
          <p><strong>Name :</strong> Mr/Mrs {userDetail.name}</p>
          <p><strong>KYC Verification :</strong> Verified</p>
          <p><strong>Subject :</strong> Approval of Loan</p>
          <p><strong>Loan Amount :</strong> ₹{userDetail.loan_amount}</p>
        </div>
        <div className="right">
          <p>Date : {userDetail.dob}</p>
          <div className="barcode">||||||||||||||||||||</div>
        </div>
      </div>

      {/* Letter Body */}
      <div className="content">
{userDetail.note}
<br />
        <h4>Payment This Account</h4>
        <p>A/C No. : {userDetail.ac_no}</p>
        <p>IFSC Code : {userDetail.ifsc_code}</p>
        <p>Branch Name : {userDetail.branch_name}</p>
        <p>Branch Address : {userDetail.branch_address}</p>
      </div>

      {/* Note */}
      <p className="note">
        Note :- Cash deposit not accepted by Company (Online Transaction Needed
        for IMPS/NEFT/RTGS/MOBILE BANKING/NET BANKING your Bank
        Account/Transaction Verification).
      </p>

      {/* Footer */}
      <div className="MudraApprovalfooter">
        <div className="sign">Your Truly<br />Authorized Business</div>
        <div className="qr">QR CODE</div>
        <div className="sign">Managing Director</div>
        <div className="sign verified">Verified By<br />Er. Soumyendu Ganguly</div>
      </div>
    </div>
  );
}
